import axios from "axios";
let BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "";
export default {
  state: {
   courseData: {},
   coursesData: [],
   myCourseData: [],
   courseError: false,
   npsAccess: []
  },
  getters: {
    getCoursedata: (state) => state.courseData,
    getcourseError: (state) => state.courseError,
    getCoursesData: (state) => state.coursesData,
    getMainCoursedata: (state) => state.myCourseData,
    getNpsAccess: (state) => state.npsAccess
  },
  actions: {
    fetchCourseData({commit},courseCode){
      axios.get(`${BASE_URL}/curriculum/main-course/${courseCode}`).then(courseData => {
        commit("setCourseData",courseData.data.data)
      }).catch(error => {
          commit("setCourseError")
      }) 
    },
    fetchAllCourseData({commit}){
      axios.get(`${BASE_URL}/curriculum/main-courses/All`).then(courseData => {
        commit("setCoursesdata",courseData.data.data)
      }).catch(error => {
          commit("setCourseError")
      }) 
    },
    fetchMyCourseData({commit}){
      axios.get(`${BASE_URL}/curriculum/assignCourse/byUserId`).then(courseData => {
        commit("setMyCoursesData",courseData.data.data)
      }).catch(error => {
          commit("setCourseError")
      }) 
    },
    checkNpsAccess({commit},courseCode){
      axios.get(`${BASE_URL}/curriculum/nps/access/${courseCode}`).then(courseData => {
        commit("setNpsAccess",courseData.data.data)
      }).catch(error => {
          commit("setNpsAccess", false)
      }) 
    },
    checkNpsClassAccess({commit},classPayload){
      axios.post(`${BASE_URL}/curriculum/nps/class/access`,classPayload).then(courseData => {
        commit("setNpsAccess",courseData.data.data)
      }).catch(error => {
          commit("setNpsAccess", false)
      }) 
    },
    saveNpsFeedbackData({commit},npsPayload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/curriculum/nps`,npsPayload).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
  },
  mutations: {
    setCourseError: (state) => (state.courseError = true),
    setCourseData: (state, courseData) => (state.courseData = courseData),
    setCoursesdata: (state, coursesData) => (state.coursesData = coursesData),
    setMyCoursesData: (state, myCoursesData) => (state.myCourseData = myCoursesData),
    setNpsAccess: (state, npsAccess) => (state.npsAccess = npsAccess)
  },
};
